import cc from 'store/util/createReduxConstant';

export const SET_MOVES_LIST_DATE_RANGE = cc('SET_MOVES_LIST_DATE_RANGE');
